import React from 'react';
import { Box, Heading, Text, VStack, Flex } from '@chakra-ui/react';

const Dashboard = () => {
  const user = JSON.parse(localStorage.getItem('loggedInUser'));

  return (
    <Flex justify="center" align="center" minH="100vh" bg="gray.50" p={4}>
      <Box bg="white" p={8} rounded="md" shadow="md" w="full" maxW="md" textAlign="center">
        <Heading mb={6} size="lg" color="blue.600">
          Welcome to TrustGrid DAPP
        </Heading>

        {user ? (
          <VStack spacing={3} align="start">
            <Text><strong>Name:</strong> {user.name}</Text>
            <Text><strong>Email:</strong> {user.email}</Text>
            <Text><strong>Phone:</strong> {user.phone}</Text>
          </VStack>
        ) : (
          <Text color="gray.500">No user information available.</Text>
        )}
      </Box>
    </Flex>
  );
};

export default Dashboard;
